function ResultCtrl($scope) {
  'ngInject';

  // ViewModel
  const vm = this;

  document.body.innerText=document.body.textContent=decodeURIComponent(window.location.hash.split('?')[1]);

}

export default {
  name: 'ResultCtrl',
  fn: ResultCtrl
};
